import { server } from "../config/server";

/** create a new blog post */
export const createNewBlogPost = (blogData, token) => {
    const formData = new FormData();
    
    formData.append('content', blogData.content);
    formData.append('title', blogData.title);
    formData.append('youtube', blogData.youtube);

    const { files } = blogData;
    if (files.length > 0) {
        for (let k = 0; k < files.length; k++) {
            formData.append('images[]', files[k]);
        }
    }

    return fetch(`${server}/blog/create`, {
        method: "POST",
        body: formData,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
}

/** get all blogs */
export const getAllBlogs = () => {
    return fetch (`${server}/blog/all`,{
        method: "GET"
    })
}